import React, { type PropsWithChildren } from "react";

import clsx from "clsx";

import barChartIcon from "@assets/tile-bar-chart-icon.svg";
import conversionLagIcon from "@assets/tile-conversion-lag-icon.svg";
import lineChartIcon from "@assets/tile-line-chart-icon.svg";
import metricIcon from "@assets/tile-metric-icon.svg";
import { TileType } from "@features/overview-v2/types";

export interface TileTypeButtonProps {
  readonly isSelected: boolean;
  readonly onClick: () => void;
  readonly tileType: TileType;
}

type TileTypeDatum = {
  src: string;
  alt: string;
  title: string;
};

const TileTypeData: { [key in TileType]: TileTypeDatum } = {
  [TileType.BAR_CHART]: {
    alt: "Bar chart tile",
    title: "Bar chart",
    src: barChartIcon,
  },
  [TileType.LINE_CHART]: {
    alt: "Line chart tile",
    title: "Line chart",
    src: lineChartIcon,
  },
  [TileType.METRIC]: {
    alt: "Metric tile",
    title: "Metric",
    src: metricIcon,
  },
  [TileType.CONVERSION_LAG]: {
    alt: "Conversion lag tile",
    title: "Conversion lag",
    src: conversionLagIcon,
  },
};

export const TileTypeButton = ({
  isSelected,
  onClick,
  tileType,
}: PropsWithChildren<TileTypeButtonProps>) => (
  <button
    className={clsx(
      "relative w-[125px] h-[120px] flex flex-col items-center justify-center",
      "border rounded-lg",
      {
        "border-2 border-v2-action": isSelected,
        "border-v2-secondary hover:border-v2-primary": !isSelected,
      },
    )}
    onClick={onClick}
  >
    <img
      src={TileTypeData[tileType].src}
      alt={TileTypeData[tileType].alt}
      style={{
        maxWidth: "100%",
        minHeight: 40,
        position: "relative",
        bottom: 6,
      }}
    />
    <div
      className="w-full text-align-center text-xs text-subtitle font-normal"
      style={{ position: "absolute", bottom: 10 }}
    >
      {TileTypeData[tileType].title}
    </div>
  </button>
);
